import { render, staticRenderFns } from "./approval-request.vue?vue&type=template&id=539e237b&scoped=true&"
import script from "./approval-request.vue?vue&type=script&lang=js&"
export * from "./approval-request.vue?vue&type=script&lang=js&"
import style0 from "./approval-request.vue?vue&type=style&index=0&id=539e237b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539e237b",
  null
  
)

export default component.exports